import {FC} from 'react'
import {StyledStatusBullet} from '@/features/treatment-requests/components/status-bullet/style.ts'
import {TreatmentRequestSmall} from '@/features/treatment-requests/types.ts'

export const StatusBullet: FC<{status: TreatmentRequestSmall['status']}> = ({status}) => (
    <StyledStatusBullet $status={status} />
)
